import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { zIndexScale } from '../../../foundations/zIndex.constants';
import { OverlayContext } from '../../../providers/OverlayContextProvider';
import { useOverlayZIndexOrder } from '../../OverlayContext/hooks/useOverlayZIndexOrder';
import { SheetDrawer } from '../SheetDrawer/SheetDrawer';
/** @deprecated Self-rendered drawer, ranked against managed overlays. Use `BottomSheet` — this is the ANCR-3039 lift list for surfaces that still drive their own back navigation. Do not add callers. */ export function StandaloneBottomSheet(props) {
    const { isTestMode } = useContext(OverlayContext);
    const zIndexOrder = useOverlayZIndexOrder(props.open);
    return /*#__PURE__*/ _jsx(SheetDrawer, _object_spread_props(_object_spread({}, props), {
        zIndex: zIndexScale.overlay + (zIndexOrder !== null && zIndexOrder !== void 0 ? zIndexOrder : 0),
        isTestMode: isTestMode
    }));
}
